export default "__VITE_ASSET__iL7OuV6v__"